// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.f-editor[data-v-5c5dcfb1] {\n  font-family: var(--font-family);\n}\n", ""]);
// Exports
module.exports = exports;
